module.exports = __webpack_public_path__ + "img/alfa.35f521e5.png";